import { AirMotor } from './types'

interface MotorImageResponse {
  thumbnail: string
  // Add other fields if needed in the future
}

export const fetchMotorImage = async (productNumber: string): Promise<string> => {
  try {
    const response = await fetch(`https://desoutter-redpim.onrender.com/cp/items/${productNumber}`)
    if (!response.ok) {
      throw new Error('Failed to fetch motor image')
    }
    const data: MotorImageResponse = await response.json()
    // Append the required suffix to the thumbnail URL
    return data.thumbnail + '/jcr:content/renditions/cq5dam.web.800.800.jpeg'
  } catch (error) {
    console.error('Error fetching motor image:', error)
    return 'placeholder.png' // Fallback to placeholder image
  }
} 